/**
 * NYMPHÉ Domain Configuration
 *
 * nymphe.co  = public brand / marketing / discovery
 * nymphe.app = private layer / access / invite / interior
 *
 * In development/preview, both resolve to the same origin.
 * In production, they are separate deployments.
 */

const APP_URL = process.env.REACT_APP_APP_URL || '';
const SITE_URL = process.env.REACT_APP_SITE_URL || '';

const hostname = window.location.hostname;
const currentOrigin = window.location.origin;

// Production = running on nymphe.co or nymphe.app (not preview, not localhost)
const isProduction = hostname === 'nymphe.co'
  || hostname === 'www.nymphe.co'
  || hostname === 'nymphe.app'
  || hostname === 'www.nymphe.app';

const onAppDomain = hostname === 'nymphe.app' || hostname === 'www.nymphe.app';
const onSiteDomain = hostname === 'nymphe.co' || hostname === 'www.nymphe.co';

/**
 * Returns the correct href for truly-private routes (/invite, /app-preview).
 * In production on nymphe.co: absolute URL to nymphe.app
 * Otherwise: relative path (same origin)
 *
 * NOTE: `/access` is PUBLIC (waitlist entry, no token required) and must use
 * `siteRoute()` instead — it only exists on the site layer.
 */
export const appRoute = (path) => {
  if (isProduction && onSiteDomain) {
    return `${APP_URL || 'https://nymphe.app'}${path}`;
  }
  return path;
};

/**
 * Returns the correct href for public routes (/, /the-app, /premium).
 * In production on nymphe.app: absolute URL to nymphe.co
 * Otherwise: relative path
 */
export const siteRoute = (path) => {
  if (isProduction && onAppDomain) {
    return `${SITE_URL || 'https://www.nymphe.co'}${path}`;
  }
  return path;
};

/**
 * Canonical invite URL for emails and backend output.
 * Always uses the app domain — never preview/dev.
 */
export const inviteUrl = (token) => {
  if (isProduction || APP_URL) {
    return `${APP_URL || 'https://nymphe.app'}/invite/${token}`;
  }
  return `${currentOrigin}/invite/${token}`;
};

/**
 * Whether current context is the private app domain
 */
export const isAppDomain = () => onAppDomain;

/**
 * Whether current context is the public site domain
 */
export const isSiteDomain = () => onSiteDomain;

/**
 * Whether we're in production
 */
export const isProd = () => isProduction;
